import { assign } from 'xstate5';

import type { CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Reverts the state of modifications and mixed dressing details to the last
 * known values, effectively discarding any pending updates.
 */
export const cancelPendingChanges: CustomizationMachineAction = assign(
  (args) => {
    const { lastKnownModifications, lastKnownMixedDressingDetails } = args.context; // prettier-ignore

    return {
      modifications: lastKnownModifications ? { ...lastKnownModifications } : undefined, // prettier-ignore
      mixedDressingDetails: [...lastKnownMixedDressingDetails],
    };
  },
);
